import React from 'react';
import { Row, Col } from 'react-bootstrap';

function ConstructionEngineering() {
  return (
    <section className="py-5 text-center">
      <div className="container">
        <h2 className="mb-5 fw-bold">Industries we Serve</h2>

        {/* Row 1 */}
        <Row className="mb-4">
          <Col md={4} className="mb-4" data-aos="fade-up" data-aos-delay="200">
            <div className="image-wrapper">
              <img src="/assets/1.jpeg" alt="Oil & Gas" className="img-fluid rounded shadow" />
            </div>
            <p className="mt-2 fw-semibold">Off shore hospitality services</p>
          </Col>
          <Col md={4} className="mb-4" data-aos="fade-up" data-aos-delay="200">
            <div className="image-wrapper">
              <img src="/assets/6.jpeg" alt="Healthcare" className="img-fluid rounded shadow" />
            </div>
            <p className="mt-2 fw-semibold">Industries Catering</p>
          </Col>
          <Col md={4} className="mb-4" data-aos="fade-up" data-aos-delay="200">
            <div className="image-wrapper">
              <img src="/assets/7.jpeg" alt="Hospitality Industry" className="img-fluid rounded shadow" />
            </div>
            <p className="mt-2 fw-semibold">Facility Management</p>
          </Col>
        </Row>

        {/* Row 2 */}
        <Row>
          <Col md={4} className="mb-4" data-aos="fade-up" data-aos-delay="200">
            <div className="image-wrapper" >
              <img src="/assets/2.jpeg" alt="Building Contracting Maintenance" className="img-fluid rounded shadow" />
            </div>
            <p className="mt-2 fw-semibold">Building Construction</p>
          </Col>
          <Col md={4} className="mb-4" data-aos="fade-up" data-aos-delay="200">
            <div className="image-wrapper" >
              <img src="/assets/5.jpeg" alt="Agriculture And Horticulture" className="img-fluid rounded shadow" />
            </div>
            <p className="mt-2 fw-semibold">Agriculture And Horticulture</p>
          </Col>
          <Col md={4} className="mb-4" data-aos="fade-up" data-aos-delay="200">
            <div className="image-wrapper" >
              <img src="/assets/img8.jpeg" alt="Hotel and Restaurent" className="img-fluid rounded shadow" />
            </div>
            <p className="mt-2 fw-semibold">Hotel and Restaurent</p>
          </Col>
        </Row>

      </div>
    </section>
  );
}

export default ConstructionEngineering;

